<template>
    <div class="options-assign">
        <div class="autosuggest-container">
            <vue-autosuggest
                v-model="query"
                :suggestions="suggestions"
                :inputProps="inputProps"
                :getSuggestionValue="getSuggestionValue"
                @selected="onSelected"
                @input="fetchResults"
                @keyup.13="keyenter = 1"
                @keyup.40="keydown = 1"
                @keydown.tab="keytab = 1"
                @mousedown="keymouse = 1"
                @item-changed="onItemChanged"
                @focus="focusMeRow"
            >
                <b-container slot-scope="{suggestion}" fluid>
                    <b-row>
                        <b-col cols="2">
                            <b-img-lazy class="products-thumbs" :src="suggestion.item.url"></b-img-lazy>
                        </b-col>
                        <b-col class="text-right">
                            {{ suggestion.item.name }}
                        </b-col>
                    </b-row>
                </b-container>
            </vue-autosuggest>
        </div>
    </div>
</template>

<script>
import { VueAutosuggest } from "vue-autosuggest"
import axios from "axios"

export default {
    name: "app",

    components: {
        VueAutosuggest
    },

    props: [ 'idx' ],

    data() {
        return {
            keydown: 0,
            keyenter: 0,
            keytab: 0,
            keymouse: 0,
            query: "",
            results: [],
            timeout: null,
            selected: null,
            currentPreSelect: null,
            // searchText: "",
            debounceMilliseconds: 500,
            inputProps: {
                id: "autosuggest__input_" + this.idx,
                style: { width: "100%" },
                placeholder: "",
                class: "form-control"
            },
            suggestions: [],
        }
    },

    methods: {
        doSearch() {
            // console.log("Searching...")
        },

        suggestFirstRow(action) {
            const hasQuery = this.query

            if (hasQuery) {
                let suggests = this.suggestions
                if (typeof suggests[0] !== 'undefined') {
                    let arr = suggests[0].data

                    if (arr.length) {
                        for (var i = 0; i < arr.length; i++) {
                            let cur = arr[i].name.toLowerCase()
                            if (cur.includes(hasQuery.toLowerCase())) {
                                this.query = arr[i].name
                                this.$emit('suggestFirstRow', this.idx, arr[i].name, arr[i].title, arr[i].price, arr[i].url, arr[i].qoh, arr[i].cost, arr[i].binA, arr[i].binB, arr[i].urlMed, arr[i].available, arr[i].mpn, arr[i].lastCost, arr[i].qoo, arr[i].vendor)

                                if (action == 'enter') {
                                    this.nextRow()
                                }

                                break;
                            } else {
                                continue
                            }
                        }
                    }
                } else {
                    this.nextRow()
                }
            } else {
                this.nextRow()
            }

            // this.query = ''
            this.suggestions = []
        },

        nextRow() {
            this.$emit('nextRow', this.idx, 'sku')
        },

        focusMeRow() {
            this.$emit('focusMeRow')
        },

        fetchResults() {
            this.keydown = 0
            const query = this.query

            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                const productsPromise = axios.get('api/inventory/generatepicturefile/getproductsfilter/' + query)

                Promise.all([productsPromise]).then(values => {
                    this.suggestions = []
                    this.selected = null

                    const products = this.filterResults(values[0].data.items, query, 'name')

                    products.length &&
                    this.suggestions.push({ name: "products", data: products })
                })
            }, this.debounceMilliseconds)
        },

        filterResults(data, text, field) {
            return data
                .filter(item => {
                    if (item[field].toLowerCase().indexOf(text.toLowerCase()) > -1) {
                        return item[field]
                    }
                })
                .sort()
        },

        getSuggestionValue(suggestion) {
            let { name, item } = suggestion
            return item.name
        },

        onItemChanged(item) {
            this.currentPreSelect = item
        },

        onSelected(item) {
            // this.doSearch(this)

            if (item) {
                this.$emit('onSelectedRow', this.idx, item.item.name, item.item.title, item.item.price, item.item.url, item.item.qoh, item.item.cost, item.item.binA, item.item.binB, item.item.urlMed, item.item.available, item.item.mpn, item.item.lastCost, item.item.qoo, item.item.vendor)

                if (this.keyenter) {
                    this.nextRow()
                    this.keyenter = 0
                }

                if (this.keytab) {
                    this.keytab = 0
                }

                if (this.keydown) {
                    this.keydown = 0
                }

                this.suggestions = []
            }
        }
    },

    watch: {
        suggestions(n, o) {
            // console.log({ n, o })
        },

        keyenter(val) {
            if (!this.suggestions.length && val == 1) {
                this.nextRow()
                this.keyenter = 0
            } else if (!this.keydown && val == 1) {
                this.suggestFirstRow('enter')
                this.keyenter = 0
            }
        },

        keytab(val) {
            if (this.suggestions.length && val == 1 && !this.keydown) {
                this.suggestFirstRow('tab')
                this.keytab = 0
            } else if (this.suggestions.length && val == 1 && this.keydown) {
                this.onSelected(this.currentPreSelect)
            }
        },

        keydown(val) {

        }
    },

    mounted() {

    }
}
</script>

<style lang="scss">
    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        margin-top: 60px;
    }

    .avatar {
        height: 25px;
        width: 25px;
        border-radius: 20px;
        margin-right: 10px;
    }

    #autosuggest__input {
        outline: none;
        position: relative;
        display: block;
        border: 1px solid #616161;
        padding: 10px;
        width: 100%;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
    }

    #autosuggest__input.autosuggest__input-open {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    .autosuggest__results-container {
        position: inline;
        width: 100%;
    }

    .autosuggest__results {
        font-weight: 300;
        margin: 0;
        position: absolute;
        z-index: 10000001;
        // width: 100%;
        border: 1px solid #e0e0e0;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        background: white;
        padding: 0px;
        max-height: 400px;
        overflow-y: scroll;
    }

    .autosuggest__results ul {
        list-style: none;
        padding-left: 0;
        margin: 0;
    }

    .autosuggest__results .autosuggest__results-item {
        cursor: pointer;
        padding: 15px;
    }

    #autosuggest ul:nth-child(1) > .autosuggest__results-before {
        border-top: none;
    }

    .autosuggest__results .autosuggest__results-before {
        color: gray;
        font-size: 11px;
        margin-left: 0;
        padding: 15px 13px 5px;
        border-top: 1px solid lightgray;
    }

    .autosuggest__results .autosuggest__results-item:active,
    .autosuggest__results .autosuggest__results-item:hover,
    .autosuggest__results .autosuggest__results-item:focus,
    .autosuggest__results
    .autosuggest__results-item.autosuggest__results-item--highlighted {
        background-color: #f6f6f6;
    }
</style>
